export const isNonEmptyString = (value: string | undefined) => value !== undefined && value.trim() !== "";
